import React, { Component } from "react";
import { routes } from "../General";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { Modal, ModalBody } from "reactstrap";
import { Contratante } from "./Contratante";
import { DeduciblesModal } from "../../coms/siniestros/DeduciblesModal";
import icono_interaccion from "assets/img/icon/interaccion.png";

export class Asegurados extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            list: [],
            dependientes: [],
            pages: -1,
            page: 0,
            loading: false,
            selected: -1,
        };
    }

    componentDidMount() {
        let { open } = this.props;
        if (open) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    fetchData() {
        let { item, poliza } = this.props;
        axios
            .post(routes.api + "/polizas/objeto", {
                cdRamoCotizacion: item.cdRamoCotizacion,
                cdRamo: poliza.cdRamo,
                cdCompania: item.cdCompania,
                cdUbicacion: item.cdUbicacion,
                dscObjeto: "",
                cedulaO: "",
                page: 0,
                pageSize: 100,
                sorted: [],
            })
            .then(resp => {
                const list = resp.data.content.filter(a => !a.exclusion);
                this.setState({list});
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    }

    getObjetos(item) {
        axios
            .get(routes.api + "/polizas/subobjetos", {
                params: {
                    cdCompania: item.cdCompania,
                    cdObjetoCotizacion: item.cdObjCotizacion,
                },
            })
            .then(resp => {
                let list = resp.data;
                this.setState({ dependientes: list });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    }

    showDeducible = open => {
        this.setState({ modalDe: open });
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [] });
    };

    calcularEdad = fecha => {
        //dar formato a las fecha
        fecha = moment(fecha).locale("moment/locale/es").local().format("DD-MM-YYYY");

        let values = fecha.split("-");
        let dia = parseInt(values[0]);
        let mes = parseInt(values[1]);
        let ano = parseInt(values[2]);

        // cogemos los valores actuales
        let fecha_hoy = new Date();
        let ahora_ano = fecha_hoy.getYear();
        let ahora_mes = fecha_hoy.getMonth() + 1;
        let ahora_dia = fecha_hoy.getDate();

        // realizamos el calculo
        let edad = ahora_ano + 1900 - ano;
        if (ahora_mes < mes) {
            edad--;
        }
        if (mes === ahora_mes && ahora_dia < dia) {
            edad--;
        }
        if (edad > 1900) {
            edad -= 1900;
        }

        // calculamos los meses
        let meses = 0;

        if (ahora_mes > mes && dia > ahora_dia) meses = ahora_mes - mes - 1;
        else if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes && dia < ahora_dia) meses = 12 - (mes - ahora_mes);
        else if (ahora_mes < mes) meses = 12 - (mes - ahora_mes + 1);
        if (ahora_mes === mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        let dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
            let ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
            dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        return edad + "a " + meses + "m " + dias + "d";
    };

    render() {
        let ramos = this.props.ramos;
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            poliza={this.props.poliza}
                            item={this.props.item}
                            user={this.props.user}
                            vida={this.props.vida}
                            ramos={ramos}
                        />

                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={() => {
                                        this.closeModal();
                                        this.setState({ dependientes: [] });
                                    }}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <h5 className="card-title">{"Asegurados"}</h5>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="text-primary">
                                        <tr>
                                            <th>Deducible</th>
                                            <th className="text-left">Apellidos Nombres</th>
                                            <th className="text-left">Fc. Nacimiento</th>
                                            <th className="text-left">Categoría</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.list.map((item, index) => (
                                            <tr
                                                key={item.cdSubObjeto}
                                                onClick={() => {
                                                    this.getObjetos(item);
                                                    this.setState({ selected: index, cedulaO: item.cedulaO });
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    backgroundColor:
                                                        index === this.state.selected ? "#47b2a2" : "white",
                                                    color: index === this.state.selected ? "white" : "black",
                                                    heigth: 35,
                                                }}
                                            >
                                                <td
                                                    className="st-120 td-actions-primary"
                                                    onClick={() => {
                                                        this.setState({
                                                            modalDedu: true,
                                                            cedulaO: item.cedulaO,
                                                        });
                                                    }}
                                                >
                                                    <span className="text-primary option px-2" title="Ver Deducibles">
                                                        <img src={icono_interaccion} className={"p-1 st-20"} />
                                                    </span>
                                                </td>
                                                <td
                                                    className="text-left st-250"
                                                    onClick={() => {
                                                        document
                                                            .getElementById("dependientedumm")
                                                            .scrollIntoView({ behavior: "smooth" });
                                                    }}
                                                >
                                                    <span>{item.dscObjeto}</span>
                                                </td>
                                                <td className="text-left">
                                                    <span>{item.fcNacimiento}</span>
                                                </td>
                                                <td className="text-left">
                                                    <span>{item.trayecto}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <DeduciblesModal
                                    open={this.state.modalDedu}
                                    toggleModal={() => this.setState({ modalDedu: false })}
                                    cedula={this.state.cedulaO}
                                    base={routes.apiVam}
                                />
                            </div>

                            <br />
                            <br />
                            <br />
                            <div id={"dependientedumm"} />
                            <h5 className="card-title">{"Dependientes"}</h5>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="text-primary">
                                        <tr>
                                            <th>Deducible</th>
                                            <th>Dependiente/Beneficiario</th>
                                            <th>Fc Nacimiento</th>
                                            <th>Parentesco/Relación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dependientes.length === 0 ? (
                                            <tr>
                                                <td colSpan={5}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {this.state.dependientes.map((item, index) => (
                                                    <tr key={item.cdSubObjeto}>
                                                        <td
                                                            className={"st-120 td-actions-primary"}
                                                            onClick={() =>
                                                                this.setState({
                                                                    modalDedu: true,
                                                                })
                                                            }
                                                        >
                                                            <span
                                                                className="text-primary option px-2"
                                                                title="Ver Deducibles"
                                                            >
                                                                <img src={icono_interaccion} className={"p-1 st-20"} />
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>{item.dscSubobjeto}</span>
                                                        </td>
                                                        <td>
                                                            <span>
                                                                {moment(item.fcNacimiento).local().format("DD/MM/YYYY")}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>{item.obsSubobjeto}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <br />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
